import { typeCreatorV2 } from 'redux/utils/common';

export const SET_PRODUCT_DOCUMENTS: string = typeCreatorV2(
  'ProductDocumentsReducer',
  'SetProductDocuments'
);

export const INSERT_PRODUCT_DOCUMENT: string = typeCreatorV2(
  'ProductDocumentsReducer',
  'InsertProductDocuments'
);

export const SET_SELECTED_DOCUMENT: string = typeCreatorV2(
  'ProductDocumentsReducer',
  'SetSelectedDocuments'
);

export const REARRANGE_DOCUMENTS: string = typeCreatorV2(
  'ProductDocumentsReducer',
  'RearrangeDocuments'
);

export const UPDATE_DOCUMENT_VISIBILITY: string = typeCreatorV2(
  'ProductDocumentsReducer',
  'UpdateDocumentVisibility'
);

export const DELETE_DOCUMENT: string = typeCreatorV2(
  'ProductDocumentsReducer',
  'DeleteDocument'
);

export const SET_DOCUMENT_INFO: string = typeCreatorV2(
  'ProductDocumentsReducer',
  'SetDocumentInfo'
);

export const UPDATE_DOCUMENT_INFO: string = typeCreatorV2(
  'ProductDocumentsReducer',
  'UpdateDocumentInfo'
);

export const UPDATE_LIST_DOCUMENT_VISIBILITY: string = typeCreatorV2(
  'ProductDocumentsReducer',
  'UpdateListDocumentVisibility'
);

export const DELETE_LIST_DOCUMENT: string = typeCreatorV2(
  'ProductDocumentsReducer',
  'DeleteListDocument'
);

export const SET_CAPTION_DOCUMENT: string = typeCreatorV2(
  'ProductDocumentsReducer',
  'SetCaptionDocument'
);

export const RESET_CAPTION_DOCUMENT: string = typeCreatorV2(
  'ProductDocumentsReducer',
  'ResetCaptionDocument'
);

export const UPDATE_CAPTION_DOCUMENT: string = typeCreatorV2(
  'ProductDocumentsReducer',
  'UpdateCaptionDocument'
);

export const RESET_SELECTED_DOCUMENT: string = typeCreatorV2(
  'ProductDocumentsReducer',
  'ResetSelectednDocument'
);
